module.exports = __webpack_public_path__ + "img/covidTestKits.0665a938.png";